import {NgModule} from '@angular/core';
import {StopClickEventPropagationDirective} from './stop-event-propagation.directive';

@NgModule({
	declarations: [StopClickEventPropagationDirective],
	exports: [StopClickEventPropagationDirective]
})
export class StopEventPropagationModule {
}
